"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/colors/common.js
// module id = 70
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460